const types = require('constants/actionTypes');

const letterSelected = ({ letter }) => (dispatch, getState) => dispatch({
    type: types.GLOSSARY_LETTER_SELECTED,
    payload: {
        letter,
        originCountry: getState().profile.get('originCountry')
    },
});

module.exports = letterSelected;
